var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    viewBox: "0 0 75 75",
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.043 1H60v73.766H15.043Zm0 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f9a92c",
    d: "M22.98 74.543a6.973 6.973 0 0 1-4.671-1.79 6.998 6.998 0 0 1-.54-9.89l24.438-27.261L18.23 13.469a7.003 7.003 0 0 1-.394-9.899 7.007 7.007 0 0 1 9.898-.394l29.051 26.812a7.008 7.008 0 0 1 .465 9.825L28.2 72.215a6.987 6.987 0 0 1-5.22 2.328Zm0 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/Up.9b61e0e9d9f5bb2e43faae7db0746391.svg";
export { ForwardRef as ReactComponent };